import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../shared/services/user.service';
import {NavbarService} from '../shared/services/navbar.service';
import {IWGSharedService} from '../shared/services/shared.service';
import {DownloadService} from '../shared/services/download.service';
import {NgForm} from '@angular/forms';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {CommonService} from '../shared/services/common.service';

@Component({
  selector: 'app-my-talent-rate',
  templateUrl: './my-talent-rate.component.html',
  styleUrls: ['./my-talent-rate.component.scss']
})
export class MyTalentRateComponent implements OnInit {

  isLoading = false;
  // Page states
  state = {};
  assignment = null;
  US_EOR = false;

  jobTitleLabel = null;
  jobLabel = null;
  allowEndClients = false;
  WorkerLabel = 'Worker';
  asssignmentLabel = 'Assignment';
  jobDescriptionLabel = null;
  jobDescriptionFileID = '';
  offerLetterFileID = '';
  SOWFileID = '';
  selectedServiceTypeIdInvaid = false;

  allowSubmit = false;
  allowEdit = false;
  myTalentRateForm = {
    selectedServiceTypeId: 0,
    selectedRattingId: 0, selectedExperienceLevelId: 0, expertiseDescription: null,
    selectedAssignmentId: 0, selectedCandidateId: 0
  };
  @ViewChild('rateform') rateform: NgForm;
  ExpertiseDescription = null;
  ServiceTypes = [];
  ExperienceLevels = [];
  Rattings = [];

  Assignments = null;
  selectedAssignmentId = 0;
  HideAssignmentsDiv = true;
  HideRattingsDiv = true;
  HideExperienceLevelDiv = true;
  HideAssignmentDetailsDiv = true;
  HideExpertiseDescriptionDiv = true;
  HideSubmitButtonDiv = true;
  selectedCandidateId = 0;
  Candidates = [];
  HideCandidatesDiv = true;

  isOpen = false;
  isServiceLoading = false;
  isWorkerOpen = false;
  isWorkerLoading = false;
  isAssignmentOpen = false;
  isAssignmentLoading = false;

  Hposition: MatSnackBarHorizontalPosition = 'right';
  VPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private router: Router, private userService: UserService, private nav: NavbarService,
              private sharedService: IWGSharedService, private download: DownloadService,
              private toast: MatSnackBar, private commonService: CommonService
  ) { }

  ngOnInit(): void {
    if (this.userService.getUser() === null) {
      this.router.navigate(['/login']);
    }
    this.ResetDivAndElements(false, false);
    Object.assign(this.myTalentRateForm, { selectedServiceTypeId: 0 });
    this.nav.show();
    this.nav.setActiveMenu('my-talent');
    this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'my-talent'});
    this.isLoading=false;
  }

  ResetDivAndElements(isCandidateChange, isAfterSave): any {

    if (!(isAfterSave)) {
      this.Assignments = []; this.selectedAssignmentId = 0;
    }
    Object.assign(this.myTalentRateForm, { selectedRattingId: 0, selectedExperienceLevelId: 0, expertiseDescription: null });

    this.HideAssignmentsDiv = true;
    this.HideRattingsDiv = true;
    this.HideExperienceLevelDiv = true;
    this.HideAssignmentDetailsDiv = true;
    this.HideExpertiseDescriptionDiv = true;
    this.HideSubmitButtonDiv = true;

    if (!(isCandidateChange) && !(isAfterSave)) {
      // Don't reset candidates while changing the candidate
      this.selectedCandidateId = 0;
      this.Candidates = [];
      this.HideCandidatesDiv = true;
    }
  }

  onExit = () => {
    if (this.sharedService.getMyRateDirty()) {
      return false;
    }
    this.sharedService.setMyRateDirty(false);
  }

  downloadJobDescriptionFile = () => {
    this.isLoading = true;
    this.download.saveAs('/Api/File/' + this.jobDescriptionFileID).then(() => {
      this.isLoading = false;
    });
  }
  downloadOfferLetterFile = () => {
    this.isLoading = true;
    this.download.saveAs('/Api/File/' + this.offerLetterFileID).then(() => {
      this.isLoading = false;
    });
  }
  downloadSOWFile = () => {
    this.isLoading = true;
    this.download.saveAs('/Api/File/' + this.SOWFileID).then(() => {
      this.isLoading = false;
    });
  }
  submit = () => {    
    if (this.rateform.valid) {
       return this.Update().subscribe((rating) => {        
         this.showConfirmationToast('Thanks for the Rating!');
         // ResetDivAndElements(false,true);
         // Take the manager to the Search page after successfull rate.
         this.sharedService.isMyRateDirty = false;
         this.router.navigate(['/my-talent-search']);
       });
    } else {      
      this.selectedServiceTypeIdInvaid = true;
    }
  }
  Update() {
    this.isLoading = true;
    this.sharedService.isMyRateDirty = false;
    const props = {};
    Object.assign(props, {
      assignment_id: this.myTalentRateForm.selectedAssignmentId,
      candidate_id: this.myTalentRateForm.selectedCandidateId,
      rating_level_id: this.myTalentRateForm.selectedRattingId,
      designation_id: this.myTalentRateForm.selectedExperienceLevelId,
      expertise: this.myTalentRateForm.expertiseDescription
    });
    return this.commonService.updateMytaletRate(props);
  }
  showConfirmationToast(text){
    this.toast.open(text, 'Got it', {
      duration: 2000, horizontalPosition: this.Hposition,
      verticalPosition: this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }
  loadMytalentsearch = () => {
    if (this.sharedService.getMyRateDirty()) {
      if (this.isConfirm()) {
        this.sharedService.setMyRateDirty(false);
        this.router.navigate(['/my-talent-search']);
      }
    }
    else {
      this.router.navigate(['/my-talent-search']);
    }
  }
  isConfirm() {
    return confirm('Are you sure you want to leave the page without submitting?')
  }
  onOpen(event){
    this.isOpen = event;
    if ( !event || this.ServiceTypes.length > 0 ){
      return;
    }
    this.isServiceLoading = true;
    this.get();
  }
  get(setId= false){
    this.commonService.getMytalentServices().subscribe(
        (data: any) => {          
          if(!data.apiCallStatus){
            return;
          }
          this.isServiceLoading = false;
          this.ServiceTypes = data.data.Data.ServiceTypes;
          this.ExperienceLevels = data.data.Data.Designations;
          this.Rattings = data.data.Data.RatingLevels;
        },
        err => {
          this.isServiceLoading = false;
          console.log(err);
        }
    );
  }
  onStateChange($event){    
    if (this.myTalentRateForm.selectedServiceTypeId > 0) {
      this.ResetDivAndElements(false, false);
      // Reset divs
      this.isLoading = true;
      this.commonService.getMytalentCandiates(this.myTalentRateForm.selectedServiceTypeId).subscribe((candidates: any) => {
        if (!candidates.apiCallStatus){
          return;
        }        
        this.Candidates = candidates.data.Data;
        this.HideCandidatesDiv = false; // Show Candidates div
        this.isLoading = false;

        if (this.myTalentRateForm.selectedServiceTypeId === 1) {
          this.asssignmentLabel = 'Assignment';
          this.jobTitleLabel = 'Job Title';
          this.jobLabel = 'Job';
          this.WorkerLabel = 'Worker';
          this.jobDescriptionLabel = 'Job Description';
        }
        else if (this.myTalentRateForm.selectedServiceTypeId == 2) {
          this.jobTitleLabel = 'Service Type';
          this.jobLabel = 'Service';
          this.WorkerLabel = 'Contractor';
          this.asssignmentLabel = 'Engagement';
          this.jobDescriptionLabel = 'Project Description';
        }
      });
    }
  }
  onworkerChange($event){
    if (this.myTalentRateForm.selectedServiceTypeId > 0 && this.myTalentRateForm.selectedCandidateId > 0) {
      this.isLoading = true;
      this.ResetDivAndElements(true, false);
      this.commonService.getMytalentAssignments(this.myTalentRateForm.selectedServiceTypeId, this.myTalentRateForm.selectedCandidateId).subscribe((assignments: any) => {
        if (!assignments.apiCallStatus){
          return;
        }        
        this.Assignments = assignments.data.Data;
        this.HideAssignmentsDiv = false;  // Show assignments div
        this.isLoading = false;
      });
    }
  }
  onAssignmentChange($event){    
    if (this.myTalentRateForm.selectedAssignmentId > 0) {
      this.isLoading = true;
      this.commonService.GetAssignmentDetailById(this.myTalentRateForm.selectedAssignmentId).subscribe((assignment: any) => {
        if (!assignment.apiCallStatus){
          return;
        }        
        assignment = assignment.data.Data;
        this.assignment = assignment;
        if (assignment.Country?.Abbreviation == 'US' && assignment.Service?.Name == 'Employer of Record') {
          this.US_EOR = true;
        }

        this.jobDescriptionFileID = assignment.JobDescriptionFile?.ID;
        this.offerLetterFileID = assignment.OfferLetterFile?.ID;
        this.SOWFileID = assignment.SOWFile?.ID;

        this.myTalentRateForm.expertiseDescription = assignment.MyTalentExpertise;
        this.myTalentRateForm.selectedRattingId = assignment.RatingLevelID;
        this.myTalentRateForm.selectedExperienceLevelId = assignment.MyTalentDesignationID;
        this.isLoading = false;
        this.HideRattingsDiv = false;
        this.HideExperienceLevelDiv = false;
        this.HideAssignmentDetailsDiv = false;
        this.HideExpertiseDescriptionDiv = false;
        this.HideSubmitButtonDiv = false;
        // $scope.isDirty = true;
        this.sharedService.setMyRateDirty(true);        
      });
    }
  }


}
